import {
  Alert,
  Button,
  // ButtonGroup,
  Dialog,
  Text,
} from '@blueprintjs/core';
import * as React from 'react';
import styled from 'react-emotion';
import { connect } from 'react-redux';
import { IState } from '../../store';
import {
  signInWithFacebook,
  signInWithGoogle,
  signOut,
} from '../../store/actions';
import Email from './Email';
import Mobile from './Mobile';
import { SignInDialogProps, SignInDialogState } from './types';

export const DialogPanelContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem 0;
`;

// const DialogText = styled(Text)`
//   margin: 1rem auto;
// `;

class LoginDialog extends React.Component<
  SignInDialogProps,
  SignInDialogState
> {
  public initialState: SignInDialogState = {
    locked: false,
    show: false,
    signInAlert: '',
    signInType: 'email',
  };

  constructor(props: SignInDialogProps) {
    super(props);

    this.state = this.initialState;
  }

  public componentDidUpdate({
    currentUser: prevCurrentUser,
  }: SignInDialogProps) {
    const { currentUser } = this.props;

    if (prevCurrentUser === null && currentUser) {
      this.setState({ show: false });
    }
  }

  public setSignInAlert = (message: string) =>
    this.setState({ signInAlert: message });

  public render() {
    const { currentUser } = this.props;
    const { signInAlert, locked, show, signInType } = this.state;
    return (
      <>
        {currentUser ? (
          <Button intent="danger" onClick={signOut} text="sign out" style={{background:'#db3737'}}/>
        ) : (
          <Button intent="primary" onClick={this.toggleDialog}>
            sign in
          </Button>
        )}
        <Dialog
          isOpen={show}
          onClose={this.toggleDialog}
          isCloseButtonShown={!locked}
          title={'sign in'}>
          {signInType === 'email' && (
            <Email
              onCloseDialog={this.closeDialog}
              onToggleDialogLock={this.toggleDialogLock}
            />
          )}
          {signInType === 'mobile' && (
            <Mobile
              onCloseDialog={this.closeDialog}
              onSetAlert={this.setSignInAlert}
              onToggleDialogLock={this.toggleDialogLock}
            />
          )}
          {/* {process.env.NODE_ENV === 'development' && (
            <>
              <DialogText>
                ...or sign in using one of the providers below
              </DialogText>
              <ButtonGroup fill={true}>
                <Button
                  disabled={locked}
                  text={signInType === 'mobile' ? 'email' : 'mobile'}
                  onClick={this.toggleSignInType}
                />
                <Button
                  disabled={locked}
                  onClick={this.facebookSignIn}
                  text="facebook"
                />
                <Button
                  disabled={locked}
                  onClick={this.googleSignIn}
                  text="google"
                />
              </ButtonGroup>
            </>
          )} */}
        </Dialog>
        <Alert
          isOpen={signInAlert ? true : false}
          onClose={this.closeSignInAlert}>
          <Text>{signInAlert}</Text>
        </Alert>
      </>
    );
  }

  public closeDialog = () => this.setState(this.initialState);

  public toggleDialogLock = (lock?: boolean) =>
    this.setState(({ locked }) => ({
      locked: typeof lock === 'boolean' ? lock : !locked,
    }));

  private closeSignInAlert = () => this.setState({ signInAlert: '' });

  // private facebookSignIn = async () => {
  //   const results = await signInWithFacebook();

  //   if (typeof results === 'string') {
  //     this.setState({ signInAlert: results });
  //   }
  // };

  // private googleSignIn = async () => {
  //   const results = await signInWithGoogle();

  //   if (typeof results === 'string') {
  //     this.setState({ signInAlert: results });
  //   }
  // };

  private toggleDialog = () => {
    const { locked } = this.state;

    this.setState(({ show }) => {
      if (locked === false) {
        return { show: !show };
      } else {
        return { show: true };
      }
    });
  };

  // private toggleSignInType = () =>
  //   this.setState(({ signInType }) => ({
  //     signInType: signInType === 'email' ? 'mobile' : 'email',
  //   }));
}

const mapStateToProps = ({ users: { currentUser } }: IState) => ({
  currentUser,
});

const mapDispatchToProps = {
  onSignInWithFacebook: signInWithFacebook,
  onSignInWithGoogle: signInWithGoogle,
  onSignOut: signOut,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LoginDialog);



// WEBPACK FOOTER //
// ./src/components/SignIn/index.tsx